import { get, set, first } from 'global/lib/lodash';
import { useSelector, useDispatch } from 'react-redux';
import { SET_VIEW } from 'redux/actions/types';
import { setViewStyle } from 'redux/actions/view';

export const useView = (props) => {
  const view = useSelector((state) => state.view);
  const dispatch = useDispatch();

  const theme = get(view, 'style.palette.type', 'light');

  const toggleTheme = () => {
    const key = 'style.palette.type';
    const theme = get(view, key, 'light');
    const themes = ['light', 'dark'];

    const _view = { ...view };

    const newTheme = first(themes.filter((t) => t !== theme));
    set(_view, key, newTheme);

    dispatch({ type: SET_VIEW, view: _view });
    dispatch(setViewStyle());
  };

  const setView = (key, value) => {
    const _view = { ...view };
    set(_view, key, value);
    dispatch({ type: SET_VIEW, view: _view });
  };

  return {
    view,
    setView,
    theme,
    isDark: theme === 'dark',
    toggleTheme,
  };
};
